module.exports = __webpack_public_path__ + "img/download-success.20dbab58.svg";